import { CarbonForIbmDotcom } from "@carbon/pictograms-react";
import { ArtTools_01 } from "@carbon/pictograms-react";
import { ServerOperatingSystems } from "@carbon/pictograms-react";
import * as React from 'react';
export default {
  CarbonForIbmDotcom,
  ArtTools_01,
  ServerOperatingSystems,
  React
};